import { render, staticRenderFns } from "./HotelsHeroSlogan.vue?vue&type=template&id=7dc5c40c"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports